import { Extension } from '@tiptap/core';

export const ValidateDoc = Extension.create({
   name: 'validateDoc',

   addOptions() {
      return {
         doc: {},
         fallbackHandler: () => {},
      };
   },

   onCreate() {
      try {
         const doc = this.editor.schema.nodeFromJSON(this.options.doc);
         doc.check();
      } catch (err) {
         this.options.fallbackHandler(err);
      }
   },
});
